import React from 'react';
import { Box, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { ListingFiltersValues } from './types';
import { EventsListing } from './EventsListing';
import { ListingFilters } from './ListingFilters';
import { INITIAL_FILTERS } from '../../constants';

export const Listing = () => {
  const form = useForm<ListingFiltersValues>({ defaultValues: INITIAL_FILTERS });

  return (
    <>
      <FormProvider {...form}>
        <Stack gap="0.5rem" sx={{ flex: 1, minHeight: 0 }}>
          <ListingFilters />

          <Box sx={{ flex: 1, minHeight: 0 }}>
            <EventsListing />
          </Box>
        </Stack>
      </FormProvider>
    </>
  );
};
